export default __webpack_public_path__ + "static/media/loader@2x.c44e3899.gif";